<template>
  <div class="shift-alert-wrapper">
    <!-- Alerta de estado de turno -->
    <div v-if="alertInfo" class="shift-alert-banner">
      <v-alert
        :type="alertInfo.type"
        :value="true"
        class="mb-3"
        icon="warning"
        dismissible
      >
        <div class="alert-content">
          <strong>{{ alertTitle }}</strong>
          <p class="mb-0 mt-1">{{ alertInfo.message }}</p>
          <div v-if="showTimeInfo" class="mt-2 time-info">
            <v-progress-linear
              :value="timeProgress"
              :color="alertInfo.type === 'error' ? 'error' : 'warning'"
              class="mb-1"
            ></v-progress-linear>
            <span class="caption grey--text">
              {{ elapsedFormatted }} / {{ maxDurationFormatted }}
            </span>
          </div>
        </div>
      </v-alert>
    </div>

    <!-- Restricción de acciones cuando no hay turno -->
    <div v-if="showAccessDenied" class="access-denied-banner">
      <v-alert
        type="error"
        :value="true"
        icon="lock"
        class="mb-3"
      >
        <strong>Acceso Restringido</strong>
        <p class="mb-0 mt-1">
          Debes iniciar un turno para acceder a esta sección.
          {{ !hasActiveShift ? 'Por favor, inicia tu turno en el panel de control.' : '' }}
        </p>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { getShiftAlertInfo, formatDuration, getElapsedTimeMs, MAX_SHIFT_DURATION_MS } from '@/services/shiftValidationService'
import { mapGetters } from 'vuex'

export default {
  name: 'ShiftAlertBanner',
  props: {
    activeShift: {
      type: Object,
      default: null
    },
    showAccessDenied: {
      type: Boolean,
      default: false
    },
    restrictAccess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updateInterval: null,
      alertInfo: null
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    hasActiveShift() {
      return !!this.activeShift
    },
    isSecurityGuard() {
      return this.getProfile && this.getProfile.roll === 9
    },
    alertTitle() {
      if (!this.alertInfo) return ''
      if (this.alertInfo.type === 'error') return '⚠️ Límite de turno excedido'
      if (this.alertInfo.type === 'warning') return '⏰ Límite de turno próximo'
      return 'Información del turno'
    },
    showTimeInfo() {
      return this.hasActiveShift && this.alertInfo && this.alertInfo.type !== 'error'
    },
    elapsedFormatted() {
      if (!this.activeShift) return '0m'
      const elapsed = getElapsedTimeMs(this.activeShift.start_time)
      return formatDuration(elapsed)
    },
    maxDurationFormatted() {
      return '24h'
    },
    timeProgress() {
      if (!this.activeShift) return 0
      const elapsed = getElapsedTimeMs(this.activeShift.start_time)
      return (elapsed / MAX_SHIFT_DURATION_MS) * 100
    }
  },
  methods: {
    updateAlert() {
      this.alertInfo = getShiftAlertInfo(this.activeShift)
    }
  },
  watch: {
    activeShift: {
      handler() {
        this.updateAlert()
      },
      deep: true
    }
  },
  mounted() {
    this.updateAlert()
    // Actualizar cada 30 segundos
    this.updateInterval = setInterval(() => {
      this.updateAlert()
    }, 30000)
  },
  beforeDestroy() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
    }
  }
}
</script>

<style scoped>
.shift-alert-wrapper {
  width: 100%;
}

.shift-alert-banner {
  animation: slideIn 0.3s ease-in-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-content {
  padding: 4px 0;
}

.time-info {
  font-size: 12px;
}

.access-denied-banner {
  margin-bottom: 20px;
}
</style>
